function toutou_xy_nuages(myJson,zoom,ctx=undefined){

  //Argument optionel
  if (zoom!=null){
    var my_zoom=zoom;
  } else {
    var my_zoom=0;
  }

  // Donnees de MySQL
  var ni       = myJson.hhh.length; 
  var data     = new Array(ni);
  var hhh      = new Array(ni);
  var time_label=new Array(ni);
  var datev    = dateo;
  var aaaammjj = myJson.aaaammjj; 
  var hh       = myJson.hh; 
  var my_fonts = new Toutou_Fonts();
  var tr       = new Toutou_Transform();
  var nptcub   = 9;

  for (var i=0; i < ni; i++) {
    data[i]=Math.min(Math.max(myJson.data1[i],0.),100.);
    hhh[i]=myJson.hhh[i];
  }
  
  pointsData['nuages'] = [];
  
  // Espace autour de la boite du graphique en %
  var pil_w=.08;
  var pil_e=.01;
  var pil_s=.2;
  var pil_n=.15;
  
  if(ctx == undefined) ctx=set_canvas('toutou_xy_nuages');

  tr.xrange(my_zoom,hhh);
  tr.ymin=0;
  tr.ymax=100;
  dimx=tr.xmax-tr.xmin;
  tr.xmin=tr.xmin-.02*dimx;
  tr.xmax=tr.xmax+.02*dimx;
  
  tr.pix_margeg=Math.round((   pil_w)*gxsize)+.5;
  tr.pix_marged=Math.round((1.-pil_e)*gxsize)+.5;
  tr.pix_margeh=Math.round((   pil_n)*gysize)+.5;
  tr.pix_margeb=Math.round((1.-pil_s)*gysize)+.5;      
  
  tr.init(my_zoom);
  
  pointsData['nuages_params'] = { xmin_pix: tr.d2px(tr.xmin), xmax_pix: tr.d2px(tr.xmax),
				  ymin_pix: tr.d2py(tr.ymin), ymax_pix: tr.d2py(tr.ymax),
				  nuages_col: 'blue'};
 
  tr.xmin_pix=tr.d2px(tr.xmin);
  tr.xmax_pix=tr.d2px(tr.xmax);
  tr.ymin_pix=tr.d2py(tr.ymin);
  tr.ymax_pix=tr.d2py(tr.ymax);      
  
  ctx.fillStyle = '#FFF';
  ctx.fillRect(0, 0, gxsize,gysize);

  tr.draw_model_zones(ctx, my_fonts, hhh, myJson.modele);

  // Titre principal
  ctx.font = my_fonts.principal;
  ctx.fillStyle = "#33A"; 
  ctx.textAlign="center";
  ctx.textBaseline="top";
  ctx.fillText('Date de départ : '+toutou_xy_titre_principal(dateo),.5*(tr.xmax_pix+tr.xmin_pix),0); 
  ctx.restore(); 
  
  // Titre secondaire
  ctx.font = my_fonts.legende;
  ctx.fillStyle = "black"; 
  ctx.textAlign="left";
  ctx.textBaseline="bottom";
  ctx.fillText('Couverture nuageuse en %',tr.xmin_pix,tr.ymax_pix-2); 
  
  // xticks
  tr.xticks_jours(datev,hhh,ctx,my_fonts,my_zoom,{time_label});
  
  // yticks
  ctx.beginPath();
  ctx.font = my_fonts.axis;
  ctx.fillStyle = "Black";
  nj=(Math.floor(tr.ymax)-Math.ceil(tr.ymin)+1);      
  inc=10;
  ctx.strokeStyle = 'black';      
  ctx.textAlign="right";
  ctx.textBaseline="middle";
  xx=Math.round(tr.xmin_pix-.01*(tr.xmax_pix-tr.xmin_pix))+.5;
  for (var i=0; i < nj; i=i+inc) {	
    yy=Math.round(tr.d2py(Math.ceil(tr.ymin)+i))+.5;
    ctx.moveTo(tr.xmin_pix,yy);
    ctx.lineTo(xx,yy);
    ctx.fillText((Math.ceil(tr.ymin)+i)+' ',xx,yy);
  }
  ctx.stroke();
  
  // Lignes grises
  for (var i=0; i < nj; i=i+inc) {
    val=Math.ceil(tr.ymin)+i;
    yy=Math.round(tr.d2py(val))+.5;
    ctx.beginPath();
    ctx.strokeStyle = '#bbb';
    ctx.moveTo(tr.xmin_pix,yy);
    ctx.lineTo(tr.xmax_pix,yy);
    ctx.stroke();
  }
  
  // Tracer %
  ctx.beginPath();
  ctx.fillStyle = pointsData['nuages_params'].nuages_col;
  ctx.strokeStyle = pointsData['nuages_params'].nuages_col;
  ctx.moveTo(tr.d2px(hhh[tr.xind_min]),tr.d2py(data[tr.xind_min]));      
  for (var i=tr.xind_min; i <= tr.xind_max; i++) {
    xx=tr.d2px(hhh[i]);
    yy=tr.d2py(data[i]);
    //ctx.lineTo(xx,yy);
    ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
    pointsData['nuages'].push({x:xx, y:yy, tl:time_label[i], pourcent:data[i]});
  }
  res=toutout_cubic_mono(hhh,data,nptcub);
  for(i=tr.xind_min*(nptcub+1);i<=tr.xind_max*(nptcub+1);i++){
    ctx.lineTo(tr.d2px(res.x[i]),tr.d2py(res.y[i]));
  }
  ctx.stroke();
  
}

